import { useState } from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  logo: {
    maxHeight: '30px',
    maxWidth: '70px',
    objectFit: 'contain'
  },
  name: {
    maxWidth: '100%',
    textAlign: 'center'
  }
});

export interface ResultIdentityProps {
  /** e.g. the project/retailer or group name; the fallback when there is no (working) image. */
  name?: string;
  imageURL?: string;
}

/**
 * Logo-or-name identity for a result row's trailing column — prefers the image (also on load
 * failure), falls back to the name, renders nothing when neither is available.
 */
export function ResultIdentity({ name, imageURL }: ResultIdentityProps) {
  const classes = useStyles();
  const [imageFailed, setImageFailed] = useState(false);

  if (imageURL && !imageFailed) {
    return <img className={classes.logo} src={imageURL} alt={name ?? 'Logo'} onError={() => setImageFailed(true)} />;
  }

  return name ? (
    <Typography variant="caption" color="textSecondary" className={classes.name}>
      {name}
    </Typography>
  ) : null;
}
